// This is the player for watching the video course.
import * as React from 'react';
import * as ReactDOM from 'react-dom';


import mount from '../utils/mounter'; 

import VideoCourseApp from '../VideoCourseApp';


mount({VideoCourseApp});
